const TagType = Object.freeze({
  STRING: 0,
  UNENFORCED_NUMBER: 1,
  UNENFORCED_DATE: 2,
  UNENFORCED_JSON: 3,
  BOOLEAN: 4,
  NUMBER: 5,
  INTEGER: 6,
  DATE: 7,
  DATETIME: 8,
  ARRAY: 9,
  OBJECT: 10
})

const TagTypeInfo = Object.freeze({
  0: {
    label: 'Tags_Field_Type_String',
    example: 'any value'
  },
  1: {
    label: 'Tags_Field_Type_Number',
    example: 'unenforced',
    unenforced: true
  },
  2: {
    label: 'Tags_Field_Type_Date',
    example: 'unenforced',
    unenforced: true
  },
  3: {
    label: 'Tags_Field_Type_Array',
    example: 'unenforced',
    unenforced: true
  },
  4: {
    label: 'Tags_Field_Type_Boolean',
    example: 'true / false'
  },
  5: {
    label: 'Tags_Field_Type_Number',
    example: '1234.5'
  },
  6: {
    label: 'Tags_Field_Type_Integer',
    example: '1234'
  },
  7: {
    label: 'Tags_Field_Type_Date',
    example: '2023-08-11'
  },
  8: {
    label: 'Tags_Field_Type_Datetime',
    example: '2023-08-11 12:00:00'
  },
  9: {
    label: 'Tags_Field_Type_Array',
    example: '["a", "b"]'
  },
  10: {
    label: 'Tags_Field_Type_Object',
    example: '{"key": "value"}'
  }
})

const TagTypeOrder = Object.freeze([0, 4, 5, 6, 7, 8, 9, 10, 1, 2, 3])

const TagTypeLabels = Object.freeze({
  0: 'Tags_Field_Type_String',
  1: 'Tags_Field_Type_Unenforced_Number',
  2: 'Tags_Field_Type_Unenforced_Date',
  3: 'Tags_Field_Type_Unenforced_Json',
  4: 'Tags_Field_Type_Boolean',
  5: 'Tags_Field_Type_Number',
  6: 'Tags_Field_Type_Integer',
  7: 'Tags_Field_Type_Date',
  8: 'Tags_Field_Type_Datetime',
  9: 'Tags_Field_Type_Array',
  10: 'Tags_Field_Type_Object'
})

const TagTypeNames = Object.freeze({
  0: 'String',
  1: 'Number',
  2: 'Date',
  3: 'JSON',
  4: 'Boolean',
  5: 'Number',
  6: 'Integer',
  7: 'Date',
  8: 'DateTime',
  9: 'Array',
  10: 'Object'
})

export { TagType, TagTypeLabels, TagTypeInfo, TagTypeOrder, TagTypeNames }



// WEBPACK FOOTER //
// ./src/modules/data-manager/enum/TagTypeEnum.js